export const Url = (url: string) => {
  return url
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-")
    .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
    .toLowerCase();
};

export const getUrlCanonical = (parentsData?: any, productIdFriendly?: string) => {
  let url = "";
  const storeMetadata = parentsData?.storeMetadata;
  const storeUseSubdomain = parentsData?.storeUseSubdomain;
  const urlOrigin = parentsData?.url;
  const catalogueId = storeMetadata?.userNetwork?.urlSummer;
  const isPrime = storeMetadata?.prime?.id !== undefined;
  const buildUrl = new URL(urlOrigin);
  url = buildUrl?.protocol === "http:" ? buildUrl?.origin?.replace("http", "https") : buildUrl.origin;
  if (!isPrime && !storeUseSubdomain) url = `${url}/catalogo/${catalogueId}`;

  if (!!productIdFriendly) {
    url = `${url}/producto/${productIdFriendly}`;
  }

  return url;
};
